import { authorize, putRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function updateUserIn2nAPI(user, data) {
  const url = `${AWS_API_URL}/2n/users/${user?.Id}`;

  let formattedCards = [];
  formattedCards = data?.rfIdTagOne ? [...formattedCards, data.rfIdTagOne] : formattedCards;
  formattedCards = data?.rfIdTagTwo ? [...formattedCards, data.rfIdTagTwo] : formattedCards;

  const filteredGroupsAndPermissions = data?.groupsAndPermissions?.filter(group => group.value !== '' && group.label !== '');
  const hasGroupsAndPermissions = filteredGroupsAndPermissions && filteredGroupsAndPermissions.length > 0;

  return putRequest(url, {
    data: {
      groupIds: hasGroupsAndPermissions ? filteredGroupsAndPermissions?.map((group) => group?.value) : [],
      isSuspended: data?.isSuspended,
      ...(formattedCards.length > 0 ? { cards: formattedCards } : { cards: [] }),
      phoneNumbers: data?.phoneNumbers,
    },
  }, await authorize());
}
